import {Config} from '../../Config'
import {AxiosQon} from '../../utils/AxiosQon'
import {Axios, AxiosResponse} from 'axios'
import {RecommendationResponse} from '../IO/Output/RecommendationResponse'

export class AxiosRecommendationRequest {
    private config: Config;
    private axios: Axios;

    constructor(config: Config) {
        this.config = config
        this.axios = (new AxiosQon(config)).axiosInstance
    }

    getRecommendations(url: string): Promise<AxiosResponse<RecommendationResponse>> {
        return this.axios.get<RecommendationResponse>(url)
    }
}